import React, { useEffect, useState } from "react"
import qs from "qs"
import _get from "lodash/get"
import { useDispatch, useSelector } from "react-redux"
import _isEmpty from "lodash/isEmpty"
import MissingImage from "@/public/images/image-missing.png"

import { isMobile } from "react-device-detect"
import {
  getAsFinalPrice,
  getAsPrice,
  getCartItemType,
  getCurrentSkuCouponDiscounts,
  getCustomerGroup,
  getMyLocation,
  getPdpFLs,
  getProductsBySku,
  getShortenedUrl,
  getUserPersona,
  pdpTypeFormat,
  recalculateCartRoomInfo,
  sanitizeDOMString,
  showNewBadge,
} from "@/utils/helper"
import { apim } from "@/constants/api"
import {
  getAsTabDetails,
  getProductBySlug,
  selectPdpState,
  setPDP,
} from "@/store/features/pdpSlice"
import ProductDetailView from "./ProductDetailView"
import { selectCartState } from "@/store/features/cartSlice"
import { setAsProductDetails } from "@/store/features/asPdpSlice"
import { getStock } from "@/utils/cart"
import CONSTANTS from "@/constants/index"
import { selectFavoritesState } from "@/store/features/favoritesSlice"
import { compareState } from "@/store/features/compareSlice"
import usePdpi18n from "@/i18n/usePdpi18n"
import isEmpty from "lodash/isEmpty"
import ProgressiveLoader from "./ProgressiveLoader"
import { addToCart as addToCartAction } from "@/store/features/cartSlice"
import { getZipCodeJsonFile } from "./productDetailsHelper"
import { addToCompareProduct, removeFromCompareProduct } from "@/utils/product"

const ProductOverview = props => {
  const {
    data: authorData = {},
    pdpData = {},
    slug: slugProp = props.slug || "",
    config = {},
  } = props
  const [availableColorFirstSku, setAvailableColorFirstSku] = useState("")

  const [slug, setSlug] = useState(slugProp)
  const [allVariantsDetails, setAllVariantsDetails] = useState([])
  const [loadShowEvent, setLoadShowEvent] = useState(false)
  const [pdprops, setPdprops] = useState({})
  const [pricesData, setPricesData] = useState([])
  const [comboSku, setComboSku] = useState([])
  const [imagesData, setImagesData] = useState([])
  const [regionSoldOnline, setRegionSoldOnline] = useState([])
  const [badgesProps, setBadgesProps] = useState()
  const [listPrices, setListPrices] = useState([])
  const [discountedPrices, setDiscountedPrices] = useState([])
  const [discountPercent, setDiscountPercent] = useState([])
  const [productSummary, setProductSummary] = useState([])
  const [productGalleryLabel, setProductGalleryLabel] = useState()
  const [orderSample, setOrderSample] = useState()
  const [productSelectYourStyle, setProductSelectYourStyle] = useState()
  const [availableColors, setAvailableColors] = useState([])
  const [isType, setIsType] = useState([])
  const [presetConfigObject, setPresetConfigObject] = useState({})
  const [videoIds, setVideoIds] = useState([])
  const [availableStock, setAvailableStock] = useState(0)
  const [colorFiles, setColorFiles] = useState([])
  const [colorNames, setColorNames] = useState([])

  const [state, setState] = useState({})
  const [reqCartData, setReqCartData] = useState({})
  const [superSku] = useState("")
  const [isParts] = useState("")
  const [selectedSku, setSelectedSku] = useState("")
  const [tabDetailsUpdate, setTabDetailsUpdate] = useState()
  const [language] = useState(config?.internationalization?.language ?? "en")
  const [plpServletPath] = useState(config?.plpServletPath)
  const [SKUInventory, setSKUInventory] = useState()
  const [showSaleBadge, setShowSaleBadge] = useState(false)
  const dispatch = useDispatch()
  const { cart, cart: { id: cartLoaded = "" } = {} } =
    useSelector(selectCartState)

  const { favorites } = useSelector(selectFavoritesState)
  const { ctData, asTabDetails: asTabDetailsFromState } =
    useSelector(selectPdpState)
  const {
    isEnable,
    comparedProducts,
    category: productCategory,
    compareSectionData,
  } = useSelector(compareState)

  const designServiceDataFromProp = authorData?.designServices ?? []
  const installationDataFromProp = authorData?.installServices ?? []
  const persona = getUserPersona()
  const overSizedType = "4"

  const {
    general = {},
    internationalization: {
      locale = "",
      currencySign = "",
      currencyCode = "",
    } = {},
  } = config
  const {
    disableCommerce: disableEcommerce = false,
    cartLandingPagePath,
    findProPagePath: findProPagePathUrl = "/",
    findStorePagePath = "",
    newBadgeName = "",
    saleBadgeName = "",
    exclusiveBadgeName = "",
    discontinuedBadgeName = "",
    lwAppName = "",
    swatchUrl = "",
  } = general
  const badgeText = {
    new: newBadgeName,
    onSale: saleBadgeName,
    exclusive: exclusiveBadgeName,
    discontinued: discontinuedBadgeName,
  }
  const staticTexts = usePdpi18n(authorData, badgeText, name)

  const {
    promoTitle = "",
    productDetailData = {},
    priceData = {},
    options = {},
    comboSkuData,
    soldByBox = "",
    soldByUom = "",
    selectMoreTooltipData = [],
    masterSku = "",
    currOptions = {},
    userZipCode = "",
    isNearest,
    servicesData = {},
    installationData = [],
    designServiceData = [],
    zipCodeData = [],
    toaster = { show: false, message: "", mobileOnly: false },
  } = state
  const {
    id,
    ProductLocalCategory_s: productLocalCategory = "",
    Product_Category: productCate = "",
    ProductCollection_s: productCollection = "",
    isCollapsedPDP_b: isCollapsedPDP = false,
    ProductBrandNameDisplay_s: productBrandNameDisplay = "",
  } = productDetailData

  useEffect(() => {
    if (promoTitle !== null) {
      getServiceData()
      getZipCodeJsonFile(state.jsonFileUrl, data => {
        const { zipcode = [] } = data
        setState(prevState => {
          return {
            ...prevState,
            zipCodeData: zipcode,
          }
        })
      })
    }
  }, [promoTitle])
  useEffect(() => {
    if (!_isEmpty(productDetailData)) {
      let imagesData = []
      let videoIds = []
      let pricesData = []
      let listPrices = []
      let colorsData = []
      let variants = []
      let colorFiles = []
      let colorNames = []
      let comboSku = []
      let orderMessaging = []
      let discountedPrices = []
      let discountPercent = []
      let requiredItemstoInstall = []
      let availableColors = []
      let colors = []
      let productSummary = []
      let productGalleryLabel = []

      let orderSample = []
      let productSelectYourStyle = []
      let soldByBox = 1
      let soldByUom = []
      let variantIds = []
      let disContinuedColors = []
      let customerSkus = []
      let isType = []
      let isRegionSoldOnline = false
      let regionSoldOnline = []
      let styleOptionsNotPresent = false

      // get list of variants
      if (productDetailData["variantList.sku_ss"]) {
        variants = productDetailData["variantList.sku_ss"]
      }
      // get list of variant colors
      if (productDetailData["Color.SKU.Details_ss"]) {
        colors = productDetailData["Color.SKU.Details_ss"].map(color => {
          const d = color.split("|")
          return {
            name: d[0],
            swatch: d[1],
            sku: d[2],
            isStock: d[3],
            discontinued: !(d[4] === "false" || Date.parse(d[4]) > Date.now()),
            customerSku: d[5],
            finishName: d[6]
          }
        })
      }

      // get list of variant Ids
      if (productDetailData["variantList.variantId_is"]) {
        variantIds = productDetailData["variantList.variantId_is"]
      }

      // get list of variant color files
      if (productDetailData["SKUColorSwatchFilename_ss"]) {
        colorFiles = productDetailData["SKUColorSwatchFilename_ss"]
      }

      // get list of variant finish names
      if (productDetailData["SKUColorFinishName_ss"]) {
        colorNames = productDetailData["SKUColorFinishName_ss"]
      }

      // get required items to install
      if (productDetailData["ProductRequiredAccessoryGroup_ss"])
        requiredItemstoInstall =
          productDetailData["ProductRequiredAccessoryGroup_ss"]

      // get Youtube Url's
      if (productDetailData["ProductYoutubeID_s"]) {
        videoIds = productDetailData["ProductYoutubeID_s"]
          .split("|")
          .map(v => ({ type: "video", url: v }))
      }
      setVideoIds(videoIds)
      setColorFiles(colorFiles)
      setColorNames(colorNames)
      //Get the product gallery new and exclusive label.
      productGalleryLabel["productExclusive"] = productDetailData[
        "ProductExclusive_s"
      ]
        ? productDetailData["ProductExclusive_s"]
        : ""

      //Get data for Product Summary component.
      productSummary["ProductPageTitle_s"] = productDetailData[
        "ProductPageTitle_s"
      ]
        ? productDetailData["ProductPageTitle_s"]
        : ""
      productSummary["productName_s"] = _get(
        productDetailData,
        "productName_s",
        ""
      )
      productSummary["ProductDesigner_s"] = _get(
        productDetailData,
        "ProductDesigner_s",
        ""
      )
      productSummary["priceListPersona"] = productDetailData[
        `PriceList${persona}.displayProductFinalPrice_s`
      ]
        ? productDetailData[`PriceList${persona}.displayProductFinalPrice_s`]
        : ""
      productSummary["ProductDescriptionProductShort_s"] = productDetailData[
        "ProductDescriptionProductShort_s"
      ]
        ? productDetailData["ProductDescriptionProductShort_s"]
        : ""
      productSummary["ProductDescriptionSmall_s"] = productDetailData[
        "ProductDescriptionSmall_s"
      ]
        ? productDetailData["ProductDescriptionSmall_s"]
        : ""

      productSummary["SKUSamples_ss"] = productDetailData["SKUSamples_ss"]
        ? productDetailData["SKUSamples_ss"]
        : ""
      productSummary["SKUBadgeInfo_ss"] = []

      productSummary["LeadTimeRange_s"] = _get(
        productDetailData,
        "LeadTimeRange_s",
        ""
      )
      productSummary["noBadge_b"] = _get(
        productDetailData,
        "noBadge_b",
        ""
      )
      productSummary["SKUInventoryStatus_s"] = _get(
        productDetailData,
        "SKUInventoryStatus_s",
        ""
      )
      productSummary["SKUAnnSacksNonStock_b"] = _get(
        productDetailData,
        "SKUAnnSacksNonStock_b",
        ""
      )
      productSummary["ProductASLeadTimeCopy_s"] = _get(
        productDetailData,
        "ProductASLeadTimeCopy_s",
        ""
      )

      //Get data for Product Select Your Style component.
      productSelectYourStyle["colorDetails"] = _get(
        productDetailData,
        "Color.SKU.Details_ss",
        ""
      )

      setProductSummary(productSummary)
      productSelectYourStyle["colorFamily"] = _get(
        productDetailData,
        "Color.Family.SKU.Details",
        ""
      )
      productSelectYourStyle["finishPopUpData"] = productDetailData[
        "Color.Family.Count.Details"
      ]
        ? productDetailData["Color.Family.Count.Details"]
        : ""
      productSelectYourStyle["ProductDescriptionDetail_s"] = productDetailData[
        "ProductDescriptionDetail_s"
      ]
        ? productDetailData["ProductDescriptionDetail_s"]
        : ""
      productSelectYourStyle["finishType"] = _get(
        productDetailData,
        "colorFinishTypeList_ss",
        ""
      )
      productSelectYourStyle["colorFinishTypeDetails"] = _get(
        productDetailData,
        "Color.Finish.Type.Details_ss",
        ""
      )
      productSelectYourStyle["selectMoreTooltipData"] = selectMoreTooltipData
      productSelectYourStyle["currentSku"] = selectedSku
      setProductSelectYourStyle(productSelectYourStyle)
      //Get order sample data
      orderSample["sampleSKUList_ss"] = productDetailData["sampleSKUList_ss"]
        ? productDetailData["sampleSKUList_ss"]
        : ""

      setOrderSample(orderSample)

      if (cart.lineItems && cart.lineItems.length > 0) {
        cart.lineItems
          .filter(item => item.productSlug["en-US"] === slug)
          .map(product => {
            if (product.discountedPrice) {
              discountedPrices[product.variant.sku] = Number(
                (product.discountedPrice.value.centAmount / 100).toFixed(2)
              )
              let percentOff
              if (
                product?.discountedPrice?.includedDiscounts[0]?.discount?.obj
                  ?.value?.type === "absolute"
              ) {
                percentOff = _get(
                  product.discountedPrice,
                  "includedDiscounts[0].discount.obj.value.money[0].centAmount",
                  0
                )
                isType[product.variant.sku] = "absolute"
              } else {
                percentOff = _get(
                  product.discountedPrice,
                  "includedDiscounts[0].discount.obj.value.permyriad",
                  0
                )
                isType[product.variant.sku] = "relative"
              }
              discountPercent[product.variant.sku] =
                percentOff > 0 ? Number(percentOff / 100) : 0
            }
          })
      }

      let variantImages = productDetailData["productImages.labelWithUrl_ss"]
      let variantImageLabels = []
      let variantImageURLs = []
      let variantResourceCredits = []
      let lifeStyleVariantImageLabels = []
      let lifeStyleVariantImageURLs = []
      let lifeStyleVariantResourceCredits = []
      let variantImageTemplates = []
      let lifeStyleVariantTemplates = []

      if (variantImages && variantImages.length > 0) {
        variantImages.map(img => {
          let imgDetail = img.split("|")
          if (selectedSku === imgDetail[0]) {
            variantImageLabels.push(imgDetail[1] + "|" + imgDetail[2])
            variantResourceCredits.push(imgDetail[3] ? imgDetail[3] : "")
            variantImageTemplates.push("LandscapeCategory")
            let _urlIndex = imgDetail.length - 1
            if (
              imgDetail[_urlIndex] &&
              imgDetail[_urlIndex].indexOf("http") > -1
            ) {
              variantImageURLs.push(imgDetail[_urlIndex])
            } else {
              variantImageURLs.push(MissingImage?.src)
            }
          }
          if (imgDetail[0]?.startsWith("IMGV")) {
            lifeStyleVariantImageLabels.push(imgDetail[1] + "|" + imgDetail[2])
            lifeStyleVariantResourceCredits.push(
              imgDetail[3] ? imgDetail[3] : ""
            )
            lifeStyleVariantTemplates.push("Lifestyle")
            let _urlIndex = imgDetail?.length - 1
            if (
              imgDetail[_urlIndex] &&
              imgDetail[_urlIndex].indexOf("http") > -1
            ) {
              lifeStyleVariantImageURLs.push(imgDetail[_urlIndex])
            } else {
              lifeStyleVariantImageURLs.push(MissingImage?.src)
            }
          }
        })
        if (variantImageURLs.length < 1) {
          variantImageLabels.push(selectedSku)
          variantImageURLs.push(MissingImage?.src)
          variantResourceCredits.push("")
        }
      } else {
        variantImageLabels.push(selectedSku)
        variantImageURLs.push(MissingImage?.src)
        variantResourceCredits.push("")
      }
      imagesData[selectedSku] = formatImages(
        variantImageLabels,
        variantImageURLs,
        variantResourceCredits,
        variantImageTemplates
      )
      imagesData["lifeStyleImageVariants"] = formatImages(
        lifeStyleVariantImageLabels,
        lifeStyleVariantImageURLs,
        lifeStyleVariantResourceCredits,
        lifeStyleVariantTemplates
      )
      setImagesData(imagesData)
      //Get the product gallery photo credit label by-default.
      productGalleryLabel["resourceCredit_s"] = imagesData[selectedSku][0]
        .resourceCredits
        ? imagesData[selectedSku][0].resourceCredits
        : ""
      productGalleryLabel["newTag"] = ""
      productGalleryLabel["isSale"] = ""

      setProductGalleryLabel(productGalleryLabel)
      for (let i = 0; i < variants.length; i++) {
        const variantSku = variants[i]
        if (allVariantsDetails?.length > 0) {
          if (allVariantsDetails[0][variantSku] !== undefined) {
            if (selectedSku === variantSku) {
              soldByUom =
                allVariantsDetails[0][variantSku]["SKUPiecesperUOM_s"] !==
                  undefined
                  ? allVariantsDetails[0][variantSku]["SKUPiecesperUOM_s"]
                  : ""
              soldByBox =
                allVariantsDetails[0][variantSku]["SKUPiecesperBOX_s"] !==
                  undefined
                  ? allVariantsDetails[0][variantSku]["SKUPiecesperBOX_s"]
                  : 1
              // Previously it was SKUReleaseforShipment_dt and now it is RegionLaunchDate_dt and this was modified for AS-8579
              let sKUReleaseforShipmentdt =
                allVariantsDetails[0][variantSku][
                  "RegionLaunchDate_dt"
                ] !== undefined
                  ? allVariantsDetails[0][variantSku][
                  "RegionLaunchDate_dt"
                  ]
                  : ""
              productGalleryLabel["newTag"] =
                sKUReleaseforShipmentdt !== ""
                  ? getDateInSixMonth(sKUReleaseforShipmentdt, Date.now())
                  : ""
              productGalleryLabel["isSale"] = _get(
                productDetailData,
                `priceList.${persona}.saleOffer_s`,
                ""
              )
              styleOptionsNotPresent = allVariantsDetails[0][variantSku]["styleOptionsNotPresent_b"] !== undefined
              if (
                allVariantsDetails[0][variantSku]["SKUBadgeInfo_ss"] !==
                undefined
              ) {
                productSummary["SKUBadgeInfo_ss"] = allVariantsDetails[0][
                  variantSku
                ]["SKUBadgeInfo_ss"]
                  ? allVariantsDetails[0][variantSku]["SKUBadgeInfo_ss"]
                  : ""
              }
            }
            setState(prevState => ({
              ...prevState,
              soldByBox,
              soldByUom,
              productSummary,
              styleOptionsNotPresent
            }))

            orderMessaging[i] = {
              id: variantSku,
              backOrderData:
                allVariantsDetails[0][variantSku]["RegionOnBackOrder_s"] !==
                  undefined
                  ? allVariantsDetails[0][variantSku]["RegionOnBackOrder_s"]
                  : "No",
              specialOrderData:
                allVariantsDetails[0][variantSku]["SKUSpecialOrder_s"] !==
                  undefined
                  ? allVariantsDetails[0][variantSku]["SKUSpecialOrder_s"]
                  : "No",
            }
          }
        }

        if (ctData.masterVariant) {
          let product = {}
          if (variantSku === ctData.masterVariant.sku)
            product = ctData.masterVariant
          else
            product = ctData.variants.find(
              variant => variantSku === variant.sku
            )
          // Get variant prices from CT data
          let priceObj = product?.prices?.find(
            price =>
              price.value?.currencyCode === currencyCode &&
              price.customerGroup?.obj?.key === persona
          )
          if (!priceObj?.value)
            priceObj = product?.prices?.find(
              price =>
                price.value?.currencyCode === currencyCode &&
                !price.customerGroup
            )
          pricesData[variantSku] = Number(
            ((priceObj?.value?.centAmount ?? 0) / 100).toFixed(2)
          )

          if (
            discountedPrices[variantSku] === 0 ||
            !discountedPrices[variantSku]
          ) {
            discountedPrices[variantSku] = Number(
              ((priceObj?.discounted?.value?.centAmount ?? 0) / 100).toFixed(2)
            )
            if (
              priceObj?.discounted?.discount?.obj?.value.type === "absolute"
            ) {
              discountPercent[variantSku] = Number(
                (priceObj?.discounted?.discount?.obj?.value?.money[0]
                  ?.centAmount ?? 0) / 100
              )
              isType[variantSku] = "absolute"
            } else {
              discountPercent[variantSku] = Number(
                (priceObj?.discounted?.discount?.obj?.value?.permyriad ?? 0) /
                100
              )
              isType[variantSku] = "relative"
            }
          }

          const listPrice = product?.prices?.find(
            price =>
              price.value?.currencyCode === currencyCode && !price.customerGroup
          )
          listPrices[variantSku] = Number(
            ((listPrice?.value?.centAmount ?? 0) / 100).toFixed(2)
          )
          setListPrices(listPrices)
          // Check if variant is a Combo SKU
          comboSku[variantSku] = product?.attributes.find(
            attr => attr.name === "ComboSKU"
          )
            ? true
            : false
          // Check if RegionSoldOnline
          const isOnline = ""
          regionSoldOnline[variantSku] = isOnline
          isRegionSoldOnline = isOnline
          setComboSku(comboSku)
          setRegionSoldOnline(regionSoldOnline)
        }
        setPricesData(pricesData)
      }
      // get data related to each color variant
      colors.forEach(color => {
        const colorObj = {
          id: color.sku,
          name: "product-color",
          value: color.sku,
          label: color.name,
          colorUrl: color.swatch !== "N/A" ? CONSTANTS.COLOR_FILE_URL + color.swatch : color.swatch,
          checked: color.sku === selectedSku ? true : false,
          discontinuedColor: color.discontinued,
          finishName: color.finishName
        }
        color.discontinued
          ? disContinuedColors.push(colorObj)
          : availableColors.push(colorObj)
        customerSkus[color.sku] = color.customerSku
      })

      const isDisContinuedColor = colors.find(
        color => color.sku === selectedSku
      )?.discontinued
      colorsData = isDisContinuedColor ? disContinuedColors : availableColors
      if (availableColors && availableColors[0])
        setAvailableColorFirstSku(availableColors[0].id ?? "")
      setAvailableColors(availableColors)
      const pdprops = {
        sku: selectedSku,
        customerFacingSKU: customerSkus[selectedSku],
        name: isParts
          ? _get(productDetailData, "productName_s", "")
          : _get(productDetailData, "ProductBrandName_s", ""),
        desc: _get(productDetailData, "ProductDescriptionProductShort_s", ""),
        customerBrandName: _get(productDetailData, "CustomerFacingBrand_s", ""),
        currencySign: currencySign,
        discontinuedProduct: _get(
          productDetailData,
          "productRegionAllVariantDiscontinued_b",
          false
        ),
        ProductRequiredAccessoriesGroupsList: _get(
          productDetailData,
          "ProductProductRecommendedAccessories_ss",
          []
        ),
        stickyHeaderProps: {
          productSku: selectedSku,
          title: isParts
            ? _get(productDetailData, "productName_s", "")
            : _get(productDetailData, "ProductBrandName_s", ""),
          description: _get(
            productDetailData,
            "ProductDescriptionProductShort_s",
            ""
          ),
          itemStatus: "available",
          color: {
            label: _get(
              colorsData.find(item => item.id === selectedSku),
              "label",
              ""
            ),
            url: _get(
              colorsData.find(item => item.id === selectedSku),
              "colorUrl",
              ""
            ),
          },
        },
        requiredItems: requiredItemstoInstall ?? [],
        productOnStock: availableStock,
        colorsData,
        addToCartProps: {
          compareChecked: Boolean(
            comparedProducts?.find(
              prod => masterSku === prod["masterSKU_s"]
            )
          ),
          backOrder: _get(
            orderMessaging.find(item => item?.id === selectedSku),
            "backOrderData",
            "No"
          ),
          specialOrder: _get(
            orderMessaging.find(item => item?.id === selectedSku),
            "specialOrderData",
            "No"
          ),
        },
        detailsProps: {
          length: _get(productDetailData, "ProductOverallLengthInches_s", 0),
          width: _get(productDetailData, "ProductOverallWidthInches_s", 0),
          height: _get(productDetailData, "ProductOverallHeightInches_s", 0),
          dimensionUnit: "in",
          detailsData: _get(productDetailData, "ProductWebFeatures_ss", []),
        },
        productIsRetail: _get(productDetailData, "ProductIsRetail", false),
        businessUnitName: _get(productDetailData, "category1_s", ""),
        productSaleable: true,
        superSku,
        productCollectionsName: _get(
          productDetailData,
          "ProductBrandNameDisplay_s",
          ""
        ),
        ProductPriceSpiderIncluded_s:
          productDetailData?.ProductPriceSpiderIncluded_s === "true"
            ? true
            : false,
        globalDiscount: Number(
          (
            pricesData[selectedSku] -
            _get(
              productDetailData,
              `priceList.${persona}.finalPrice_d`,
              pricesData[selectedSku]
            )
          ).toFixed(2)
        ),
        freightPolicyType: _get(
          productDetailData,
          "ProductFreightPolicyType_s",
          ""
        ),
        productPartnerBuyNow: false,
        isFavorite:
          favorites?.lineItems?.some(
            obj => obj?.variant?.sku === selectedSku
          ) ?? false,
        favItem: favorites,
        ctData: ctData.id,
      }

      if (
        pdprops.ProductPriceSpiderIncluded_s ||
        isDisContinuedColor ||
        !isRegionSoldOnline
      ) {
        if (pdprops.ProductPriceSpiderIncluded_s) {
          pdprops.productPartnerBuyNow = true
        }
        pdprops.productSaleable = false
      }
      setPdprops(pdprops)

      //Get badge values for product
      const shipmentDate = _get(
        productDetailData,
        "RegionLaunchDate_dt",
        ""
      )
      const badgesProps = {
        isNewProduct: showNewBadge(shipmentDate),
        badgeVal: _get(
          productDetailData,
          `priceList.${persona}.saleOffer_s`,
          ""
        ),
        exclusiveBadge: _get(productDetailData, "ProductExclusive_s", ""),
      }
      setBadgesProps(badgesProps)
      setDiscountedPrices(discountedPrices)
      setDiscountPercent(discountPercent)
      setIsType(isType)
      const saleDetailsSS = productDetailData[`Sale.${persona}.Details_ss`];
      const selectedSkuSaleDetails = saleDetailsSS?.find(saleDetail => saleDetail?.split("|")[0] === selectedSku)
      setShowSaleBadge(selectedSkuSaleDetails?.split('|')[1] === 'Yes')
    }
  }, [productDetailData, allVariantsDetails, selectedSku, ctData, favorites])

  useEffect(() => {
    if (!_isEmpty(authorData) && !_isEmpty(general)) {
      const { presetConfigs = "{}" } = authorData ?? { presetConfigs: "{}" }
      const presetConfigObject = JSON.parse(presetConfigs)
      setPresetConfigObject(presetConfigObject)
    }
  }, [authorData, general])
  useEffect(() => {
    if (productCollection && productLocalCategory && isCollapsedPDP) {
      getOptions()
    }
  }, [
    productCollection,
    productLocalCategory,
    isCollapsedPDP,
    productDetailData,
  ])
  useEffect(() => {
    setSlug(slugProp)
  }, [slugProp])

  const fetchSkuFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const urlSku = sanitizeDOMString(urlParams.get("skuId"))
    setSelectedSku(urlSku ? urlSku : selectedSku)
  }

  const onPageLoad = () => {
    try {
      fetchSkuFromUrl()
      const fl = getPdpFLs(persona).join(",")
      apim
        .post(`search/pdp/${slug}`, {
          fl,
          q: "*:*",
          fq: `language_s:("${language}")`,
          collections: lwAppName.toLowerCase(),
          profilename: isParts
            ? `profile_service_parts_PDP`
            : `profile_${lwAppName.toLowerCase()}_PDP`,
          profilename: `profile_${lwAppName.toLowerCase()}_PDP`,
          search_type: "product_overview",
        })
        .then(res => {
          if (res && res.data) {
            dispatch(setAsProductDetails(res.data))
            const productData = _get(res.data, "response.docs[0]", {})
            if (productData["variantList.sku_ss"]) {
              getVarientsInfo(productData, productData["variantList.sku_ss"])
            }
            let isCurated = false
            let productConfiguration =
              res.data.response?.docs[0]?.ProductConfiguration_ss ?? false
            if (
              productConfiguration &&
              productConfiguration[0] === "Curated Bath"
            ) {
              isCurated = true
            }

            //Curated Bath Collection
            const comboSkuDetails = _get(res.data, "fusion.ComboSkuDetails", [])
            //curated bath child combo
            const childSelectedSku =
              comboSkuDetails &&
              comboSkuDetails.length > 0 &&
              comboSkuDetails.find(size => size.selected_b === true)
            const childSkuDetails = childSelectedSku.ChildSKUDetails

            setState(prevState => {
              return {
                ...prevState,
                productDetailData: productData,
                viewLoader: false,
                masterSku: _get(productData, "masterSKU_s", ""),
                comboSkuData: comboSkuDetails,
                childSkuData: childSkuDetails,
                priceData: {
                  ...priceData,
                  lwAnyPrice: productData["priceList.ANY.price_d"]
                    ? productData["priceList.ANY.price_d"]
                    : "",
                },
              }
            })
            setTabDetailsUpdate(true)
            localStorage.setItem("itemFinalPrice", 0)
            // set product tab details
            setProductTabDetails(
              productData,
              childSkuDetails,
              comboSkuDetails,
              isCurated
            )
          }
          dispatch(getProductBySlug(slug))
        })
    } catch (err) {
      console.log("catch err pdp onPageload")
    }
    getServiceData()
  }

  useEffect(() => {
    const a = async () => {
      if (!_.isEmpty(ctData)) {
        const { customerGroup = "", fallbackCustomerGroup = "" } =
          await getCustomerGroup()
        const masterVariant = _get(ctData, "masterVariant", {})
        const variants = _get(ctData, "variants", [])
        const allVariants = [...variants, masterVariant]
        const allAsPrice = getAsPrice(
          allVariants,
          ["stand-alone-price", "prices"],
          customerGroup,
          fallbackCustomerGroup,
          currencyCode
        )

        setState(prevState => ({
          ...prevState,
          priceData: { ...priceData, ...allAsPrice },
        }))
      }
    }
    a()
  }, [ctData])

  useEffect(() => {
    onPageLoad()
  }, [lwAppName])

  const setProductTabDetails = (
    productData,
    childSkuDetails,
    comboSkuDetails,
    isCurated
  ) => {
    // TECHNICAL INFORMATION
    let technicalTabs = []
    if (comboSkuDetails && comboSkuDetails.length > 0) {
      const technical = childSkuDetails.Technical ?? ""
      technicalTabs = technical.map(item => ({
        brandName: item.ProductBusinessUnit_ss[0] || "", // Annsacks
        category: item.ProductLocalCategory_s || "",
        description: item["ProductWebTechnology_ss"] || "",
        specSheet:
          item["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"] || "",
        installation:
          item[
          "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"
          ] || "",
        threeDRevit: "",
        twodDWGPlanView:
          item["ProductResource.DWGPlanView.resourceFullWebURL_ss"] || "",
        DXFPlanView:
          item["ProductResource.DXFPlanView.resourceFullWebURL_ss"] || "",
        twodFrontView:
          item["ProductResource.DWGFrontView.resourceFullWebURL_ss"] || "",
        DXFFrontView:
          item["ProductResource.DXFFrontView.resourceFullWebURL_ss"] || "",
        twoDSideView:
          item["ProductResource.DWGSideView.resourceFullWebURL_ss"] || "",
        DXFSideView:
          item["ProductResource.DXFSideView.resourceFullWebURL_ss"] || "",
        HomeownersGuide:
          item["ProductResource.HomeownersGuide.resourceFullWebURL_ss"] || "",
      }))
    } else {
      technicalTabs = [
        {
          description:
            (productData && productData["ProductWebTechnology_ss"]) || "",
          brandName:
            (productData && productData["CustomerFacingBrand_s"]) || "",
        },
      ]
    }
    //FEATURES INFORMATION:
    let featureTabs = []
    if (comboSkuDetails && comboSkuDetails.length > 0) {
      const features = childSkuDetails.Feature || ""
      featureTabs =
        features &&
        features.map(item => ({
          brandName: item.ProductBusinessUnit_ss[0] || "",
          productLocalCategory: item.ProductLocalCategory_s || "",
          description: item["ProductWebFeatures_ss"] || "",
        }))
    }
    const asTabDetails = {
      tabData: {
        details: {
          description:
            (productData && productData["ProductNarrativeDescription_s"]) || "",
          tearSheet:
            (productData &&
              productData[
              "ProductResource.TearSheetPDF.resourceFullWebURL_ss"
              ]) ||
            "",
        },
        recommendedUse: {
          description:
            (productData && productData["ProductWebFeatures_ss"]) || "",
        },
        technicalTab: technicalTabs,
        featureTab: featureTabs,
      },
      selectedVariantSku: state.selectedSku || productData.masterSKU_s,
      productGenericDescription: productData["ProductDescriptionGeneric_s"]
        ? productData["ProductDescriptionGeneric_s"]
        : "",
      priceList: productData["priceList.ANY.price_d"]
        ? productData["priceList.ANY.price_d"]
        : "",
      productBrandNameDisplay: productData["ProductBrandNameDisplay_s"],
      isCurated: isCurated,
    }

    if (Object.keys(asTabDetailsFromState).length === 0 || tabDetailsUpdate) {
      setTabDetailsUpdate(false)
      dispatch(getAsTabDetails(asTabDetails))
    }
  }

  const getUserLocation = () => {
    getMyLocation().then(getLocation => {
      setState(
        prevState => (
          { ...prevState, userZipCode: getLocation.zipcode ?? "" },
          () => checkUserZipCode(th.userZipCode)
        )
      )
    })
  }
  const getServiceData = async () => {
    if (!_isEmpty(designServiceDataFromProp)) {
      const designServicesSkus = designServiceDataFromProp.map(product => {
        if (product.sku) {
          return product.sku
        }
      })
      const productData = await getProductsBySku(designServicesSkus)
      setState(prevState => ({
        ...prevState,
        designServiceData: productData,
      }))
    }
    if (!_isEmpty(installationDataFromProp)) {
      const installtionSkus = installationDataFromProp.map(list => {
        if (list.sku) {
          return list.sku
        }
      })
      const getInstallationData = await getProductsBySku(installtionSkus)
      setState(prevState => ({
        ...prevState,
        installationData: getInstallationData,
      }))
      getUserLocation()
    }
  }
  const getVarientsInfo = (productsData, varientId) => {
    let tmpId = ""
    if (varientId && varientId?.length > 0) {
      let i
      for (i = 0; i < varientId.length; i++) {
        let tmpVariants = '"' + varientId[i] + '"'
        tmpId = tmpId + tmpVariants + ","
      }
      tmpId = tmpId != "" ? tmpId.substring(0, tmpId.lastIndexOf(",")) : ""
    }

    apim
      .post(`search/pdp/${slug}`, {
        q: "*:*",
        fl: "sku_s,slug_s,id,RegionDiscontinuedDate_dt, RegionOnBackOrder_s, RegionStatesExcluded_ss, SKUBadgeInfo_ss, SKUPiecesperBOX_s, SKUPiecesperUOM_s, SKUReleaseforShipment_dt,RegionLaunchDate_dt, RegionSpecialOrder_s, ctId_s, SKUInventoryStatus_s, SKUAnnSacksNonStock_b, noBadge_b, styleOptionsNotPresent_b",
        fq: `sku_s:(${tmpId}),language_s:("${language}")`,
        collections: isParts ? "service_parts" : lwAppName.toLowerCase(),
        profilename: isParts
          ? `profile_service_parts_PDP`
          : `profile_${lwAppName.toLowerCase()}_PDP`,
        search_type: "product_overview",
      })
      .then(variantsResult => {
        if (variantsResult && variantsResult.data) {
          const variantsData = _get(variantsResult.data, "response.docs", {})
          let tmpVariantsData = []
          let tmpVariantsInfo = []
          let k
          for (k = 0; k < variantsData.length; k++) {
            let tmpSku = variantsData[k]["sku_s"]
              ? variantsData[k]["sku_s"]
              : ""
            if (tmpSku) {
              tmpVariantsInfo[tmpSku] = variantsData[k]
            }
          }
          tmpVariantsData.push(tmpVariantsInfo)
          const inventoryStatus =
            tmpVariantsInfo[selectedSku]?.SKUAnnSacksNonStock_b
          setAllVariantsDetails(tmpVariantsData)
          setSKUInventory(inventoryStatus)

          const sku =
            selectedSku === ""
              ? getInitialSku(
                varientId,
                productsData["masterSKU_s"],
                tmpVariantsData
              )
              : selectedSku
          let recommendedAccessories = []
          if (productsData["ProductProductRecommendedAccessories_ss"]) {
            recommendedAccessories =
              productsData["ProductProductRecommendedAccessories_ss"]
          } else if (productsData["ProductProductRecommendedAccessories_s"]) {
            recommendedAccessories.push(
              productsData["ProductProductRecommendedAccessories_s"]
            )
          }
          setAsProductDetails({
            sku,
            slug,
            recommendedAccessories,
          })
          dispatch(setPDP({ sku, slug, recommendedAccessories }))
          setSelectedSku(sku)
          setTabDetailsUpdate(true)

          if (sku) {
            getAvailableStock(sku)
          }

          window.addEventListener("popstate", () => {
            fetchSkuFromUrl()
            getAvailableStock(sku)
            dispatch(setAsProductDetails({ sku }))
            dispatch(setPDP({ sku }))
          })
        }
      })
  }
  const getInitialSku = (varientId, masterSKU_s, productVariantData) => {
    let availableSkus = []
    if (productVariantData?.length > 0) {
      let variants = varientId
      variants.map((variant, i) => {
        let discontinuedColor = false
        if (productVariantData[0][variant]) {
          discontinuedColor =
            productVariantData[0][variant]["RegionDiscontinuedDate_dt"] !==
              undefined
              ? productVariantData[0][variant]["RegionDiscontinuedDate_dt"] !==
              false &&
              Date.parse(
                productVariantData[0][variant]["RegionDiscontinuedDate_dt"]
              ) < Date.now()
              : false
        }
        if (!discontinuedColor) availableSkus.push(variant)
      })
    }
    return availableSkus[0] ?? masterSKU_s
  }
  const getAvailableStock = async sku => {
    if (!disableEcommerce) {
      const count = await getStock(sku).then(qty => {
        return qty
      })
      setAvailableStock(count)
    }
    setLoadShowEvent(true)
  }
  const setSkuVariant = (sku, finish = "") => {
    if (sku) {
      setTabDetailsUpdate(true)
      setSelectedSku(sku)
    }

    getAvailableStock(sku)
    const url = new URL(window.location.href)
    let searchParams = url.searchParams
    searchParams.set("skuId", sku)
    finish !== "" ? searchParams.set("finish", finish) : ""
    const urlSearch = "?" + searchParams.toString()
    window.history.replaceState(
      window.location.pathname,
      document.title,
      urlSearch
    )
    dispatch(setPDP({ sku }))
  }
  const checkProductCategory = () => {
    if (
      compareproductsCategory === productCate ||
      compareproductsCategory === ""
    ) {
      return true
    }
    return false
  }
  const formatImages = (labels, urls, ResourceCredits, templates) => {
    const images = []
    for (let i = 0; i < urls.length; i++) {
      images.push({
        label: labels[i] ?? "",
        url: urls[i],
        resourceCredits: ResourceCredits[i],
        template: templates[i],
      })
    }
    return images
  }
  const addRequiredItems = list => {
    setReqCartData(list)
  }
  const addToCart = (items, cb) => {
    let totalAdded = 0
    items.forEach(item => (totalAdded += item.quantity))
    let itemCountMessage =
      totalAdded === 1
        ? `(${totalAdded}) ${staticTexts.itemAdded} `
        : `(${totalAdded}) ${staticTexts.itemsAdded} `
    const ToasterMssg = () => (
      <>
        {itemCountMessage}
        <a href={cartLandingPagePath}>{staticTexts.yourCart}</a>.
      </>
    )
    dispatch(
      addToCartAction(
        [...items, ...reqCartData],
        true,
        "",
        cb,
        false,
        null,
        false,
        isMobile && window?.outerWidth < 1024
          ? () => showToaster(<ToasterMssg />)
          : null
      )
    )
  }
  const showToaster = (mssg, mobileOnly) => {
    setState(prevState => ({
      ...prevState,
      toaster: { show: true, message: mssg, mobileOnly: mobileOnly ?? false },
    }))
    setTimeout(
      () =>
        setState(prevState => ({
          ...prevState,
          toaster: { show: false, message: "", mobileOnly: false },
        })),
      3000
    )
  }

  // Get list of available options to be shown under Select More Options
  const getOptions = async () => {
    const { data } = await apim.get(`/search/plp`, {
      params: {
        fl: "slug_s",
        q: "*:*",
        rows: "1",
        fq: [
          `Collapse_Field_s:("${productLocalCategory} ${productCollection}")`,
          `isCollapsedPDP_b:${isCollapsedPDP}`,
        ],
        profilename: `profile_${lwAppName.toLowerCase()}_PDP`,
        collections: lwAppName.toLowerCase(),
      },
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: "repeat", encode: true })
      },
    })
    let curOptions = {}
    if (data && data?.facet_counts?.facet_fields) {
      const facets = data.facet_counts.facet_fields ?? {}
      Object.entries(facets).map(facet => {
        if (productDetailData[facet[0]]) {
          curOptions[facet[0]] = productDetailData[facet[0]] ?? ""
        }
      })
      setState(prevState => ({
        ...prevState,
        options: facets,
        currOptions: curOptions,
      }))
    }

    apim
      .get(`/search/tooltip`, {
        params: {
          collection: lwAppName.toLowerCase(),
        },
      })
      .then(res => {
        if (res && res.data) {
          const tooltipData = res.data ?? {}
          setState(prevState => ({
            ...prevState,
            selectMoreTooltipData: tooltipData,
          }))
        }
      })
  }

  // Search for product variant based on selected option and redirect to that PDP
  const selectOption = async (value, facet, datalayerTitle = null) => {
    const modifiedValue = decodeURIComponent(value).replace(/"/g, '\\"')
    apim
      .get(`/search/plp`, {
        params: {
          fl: "slug_s,ProductLocalCategory_s,masterSKU_s,ProductDescriptionProductShort_s,priceList.*.saleOffer_s,priceList.ANY.price_d,Color.SKU.Details_ss,ProductBrandName_s,ProductDetailImageURL_s,productName_s,ProductPriceSpiderIncluded_s, pdp_url_s",
          q: "*:*",
          rows: "1",
          fq: [
            `ProductBrandNameDisplay_s:("${productBrandNameDisplay}")`,
            `ProductLocalCategory_s:("${encodeURIComponent(
              productLocalCategory
            )}")`,
            `${facet}:("${modifiedValue}")`,
          ],
          profilename: `profile_${lwAppName.toLowerCase()}_PDP`,
          collections: lwAppName.toLowerCase(),
        },
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: "repeat", encode: false })
        },
      })
      .then(async result => {
        if (datalayerTitle) {
          const selectedProductInfo = await getSelectedProductInfo(
            result?.data?.response?.docs[0]
          ).then(res => {
            return res
          })
          addDataLayer({
            title: `${datalayerTitle}`,
            shapeVal:
              result?.data?.response?.docs[0]?.["ProductDetailImageURL_s"]
                ?.split("|")?.[0]
                ?.toLowerCase?.() || "",
            productInfo: selectedProductInfo?.toLowerCase(),
          })
        }
        if (result) {
          const slug = _get(result, "data.response.docs[0].slug_s", "")
          if (slug) {
            if (productLocalCategory && plpServletPath) {
              let pdpPageDetails = plpServletPath.find(el =>
                el.categories.includes(productLocalCategory)
              )
              window.location = pdpPageDetails
                ? pdpPageDetails?.url
                  ? getShortenedUrl(pdpPageDetails.url + "/" + slug + ".html")
                  : ""
                : ""
            }
          }
        }
      })
  }

  const getSelectedProductInfo = async data => {
    let selectedDiscountedPrice, selectedPercentOff, selectedDiscountPercent
    cart.lineItems
      .filter(item => item.productSlug["en-US"] === data?.["slug_s"])
      .map(product => {
        if (product.discountedPrice) {
          selectedDiscountedPrice = Number(
            (product.discountedPrice.value.centAmount / 100).toFixed(2)
          )
          if (
            product?.discountedPrice?.includedDiscounts[0]?.discount?.obj?.value
              ?.type === "absolute"
          ) {
            selectedPercentOff = _get(
              product.discountedPrice,
              "includedDiscounts[0].discount.obj.value.money[0].centAmount",
              0
            )
          } else {
            selectedPercentOff = _get(
              product.discountedPrice,
              "includedDiscounts[0].discount.obj.value.permyriad",
              0
            )
          }
          selectedDiscountPercent =
            selectedPercentOff > 0 ? Number(selectedPercentOff / 100) : 0
        }
      })
    const selectedColorDetail = data?.["Color.SKU.Details_ss"]?.find(
      color => color?.split("|")?.[2] === data?.["masterSKU_s"]
    )
    const { productCouponCode, productCoupondiscount } =
      getCurrentSkuCouponDiscounts({
        cart,
        sku: data?.["masterSKU_s"],
      })
    const imageUrl = data?.["ProductDetailImageURL_s"]?.split("|")?.[1]
    const stockCount = await getStock(data?.["masterSKU_s"]).then(qty => {
      return qty
    })
    return JSON.stringify({
      description: data?.["ProductDescriptionProductShort_s"] || "n/a",
      frequency: "n/a",
      globalPromotionPrice:
        Number(selectedDiscountedPrice) ||
        Number(data?.["priceList.ANY.price_d"]) ||
        "n/a",
      isRecommended: "n/a",
      isSendNow: "n/a",
      isSubscription: "n/a",
      priceState:
        Number(selectedDiscountPercent) > 0
          ? "percentOff|" + selectedDiscountPercent
          : "regular price",
      productBasePrice: Number(data?.["priceList.ANY.price_d"]) || "n/a",
      productCategory: data?.["ProductLocalCategory_s"] || "n/a",
      productColor: selectedColorDetail?.split("|")?.[0] || "n/a",
      productCoupondiscount: productCoupondiscount,
      productCouponCode: productCouponCode.join("|") || "n/a",
      productID: data?.["masterSKU_s"] || "n/a",
      productName: data?.["productName_s"] || "n/a",
      productPartnerBuyNow: data?.["ProductPriceSpiderIncluded_s"]
        ? true
        : false,
      productRoom: data?.["ProductLocalCategory_s"] || "n/a",
      productSalePrice: Number(selectedDiscountedPrice)
        ? Number(selectedDiscountedPrice)
        : Number(data?.["priceList.ANY.price_d"]) || "n/a",
      productSaleable: data?.["RegionSoldOnline"] || "n/a",
      productStatus: stockCount > 0 ? "in stock" : "out of stock",
      productSuperSku: "n/a",
      productTileName: data?.["productName_s"] || "n/a",
      quantity: 1,
      defaultImageName: imageUrl || "n/a",
      ratings: "n/a",
      numberOfReviews: "n/a",
      pdpType: pdpTypeFormat({
        businessUnitName: data?.["ProductLocalCategory_s"],
        ProductPriceSpiderIncluded_s: data?.["ProductPriceSpiderIncluded_s"],
        discontinuedProductb: !data?.["RegionSoldOnline"],
        ProductRequiredAccessoriesGroupsList:
          data?.["ProductRequiredAccessoryGroup_ss"],
        superSku: data?.["masterSKU_s"],
      }),
      productFindingMethod: "n/a",
      productCollectionsName: data?.["productName_s"] || "n/a",
      productBrand: data?.["CustomerFacingBrand_s"] || "n/a",
      globalOffer: data?.[`priceList.${persona}.saleOffer_s`] || "n/a",
      globalDiscount: Number(selectedDiscountedPrice)
        ? Number(data?.["priceList.ANY.price_d"]) -
        Number(selectedDiscountedPrice)
        : 0,
      itemType: getCartItemType(
        data?.["ProductLocalCategory_s"],
        data?.["CustomerFacingBrand_s"]
      ),
    })
  }
  const seeAvailableColor = () => {
    setSkuVariant(availableColorFirstSku, "")
  }

  const getZipCode = zipCodeVal => {
    setState(
      prevState => (
        {
          ...prevState,
          userZipCode: zipCodeVal,
        },
        () => checkUserZipCode(zipCodeVal)
      )
    )
  }
  const checkUserZipCode = userZipCodeVal => {
    let newCodes = []
    zipCodeData.map(codes => {
      Object.keys(codes).forEach(key => {
        newCodes.push(codes[key].includes(userZipCodeVal))
      })
    })
    setState(prevState => ({
      ...prevState,
      isNearest: newCodes.find(result => result === true) ? true : false,
    }))
  }
  const getDateInSixMonth = (productDate, currentDate) => {
    let newDate = new Date(currentDate)
    let productNewDate = new Date(productDate)
    let dateDiff = new Date(newDate.setMonth(newDate.getMonth() - 6))
    if (dateDiff.getTime() <= productNewDate.getTime()) {
      return "Yes"
    }
    return ""
  }
  const updateRecalculateRoomInfo = (
    lineItemId,
    recalculateAdditionalInfo,
    customQuantity,
    cb
  ) => {
    let itemCountMessage =
      customQuantity > 0
        ? `${customQuantity} ${staticTexts.itemAdded} `
        : `${staticTexts.updateItemsErrorMsg} `
    const ToasterMsg = () => (
      <>
        {itemCountMessage}
        <a href={cartLandingPagePath}>{staticTexts.yourCart}</a>.
      </>
    )
    recalculateCartRoomInfo(
      lineItemId,
      recalculateAdditionalInfo,
      Number(window?.outerWidth) < 1024 ? false : true,
      cb,
      isMobile && window?.outerWidth < 1024
        ? () => showToaster(<ToasterMsg />)
        : null
    )
  }
  return !isEmpty(productDetailData) ? (
    <ProductDetailView
      {...pdprops}
      RegionUOM={productDetailData?.["RegionAltUOM_s"]}
      productImages={productDetailData['productImages.labelWithUrl_ss']}
      persona={isParts ? null : persona}
      toaster={toaster}
      staticTexts={staticTexts}
      options={options}
      currOptions={currOptions}
      productCategoryType={productCate}
      isComboSku={comboSku[selectedSku]}
      imagesData={[
        ...Object.values(imagesData[selectedSku] || []),
        ...Object.values(imagesData["lifeStyleImageVariants"] || []),
        ...videoIds,
      ]}
      isRegionSoldOnline={regionSoldOnline[selectedSku]}
      badgesProps={badgesProps}
      price={getAsFinalPrice(
        priceData[[selectedSku]],
        null
      )}
      pricePerBox={pricesData[selectedSku]}
      listPrice={listPrices[selectedSku]}
      discountedPrice={getAsFinalPrice(priceData[[selectedSku]], true)}
      discountedPricePerBox={discountedPrices[selectedSku]}
      discountPercent={discountPercent[selectedSku]}
      setSkuVariant={(sku, finish) => setSkuVariant(sku, finish)}
      selectOption={(val, facet, datalayerTitle) =>
        selectOption(val, facet, datalayerTitle)
      }
      getStock={() => getStock(selectedSku)}
      onAddToCart={(cartValue, cb) => addToCart(cartValue, cb)}
      onAddToCompare={() => addToCompareProduct(
            selectedSku,
            productDetailData,
            lwAppName,
            persona,
            compareSectionData,
          )}
      onRemoveFromCompare={() => removeFromCompareProduct(selectedSku)}
      checkProductCategory={() => checkProductCategory()}
      comparedProductsCount={comparedProducts?.length}
      isEnable={isEnable}
      findProPagePath={findProPagePathUrl}
      locale={locale}
      currencySign={currencySign}
      currencyCode={currencyCode}
      addItemsToCart={list => addRequiredItems(list)}
      showToaster={(mssg, mob) => showToaster(mssg, mob)}
      onAvailableColor={() => seeAvailableColor()}
      overSizedType={overSizedType}
      userZipCode={userZipCode}
      isNearest={isNearest}
      cart={cart}
      getZipCode={zipCodeVal => getZipCode(zipCodeVal)}
      servicesData={servicesData}
      installationData={installationData}
      designServiceData={designServiceData}
      installationDataFromProp={installationDataFromProp}
      designServiceDataFromProp={designServiceDataFromProp}
      findStoreUrl={findStorePagePath}
      promoTitle={promoTitle}
      promoDescription={state.promoDescription}
      enablePromo={state.enablePromo}
      productSummaryDetails={productSummary}
      productGalleryLabel={productGalleryLabel}
      soldByBox={soldByBox}
      soldByUom={soldByUom}
      orderSample={orderSample}
      brandNameDisplay={productBrandNameDisplay}
      ProductLocalCategory_s={productLocalCategory}
      productCollection={productCollection}
      productSelectYourStyle={productSelectYourStyle || {}}
      customLabel={{ ...staticTexts, ...authorData }}
      authorData={{ ...staticTexts, ...authorData }}
      availableColors={availableColors}
      selectMoreTooltipData={selectMoreTooltipData}
      isType={isType[selectedSku]}
      updateRecalculateRoomInfo={(
        lineItemId,
        recalculateAdditionalInfo,
        customQuantity,
        cb
      ) =>
        updateRecalculateRoomInfo(
          lineItemId,
          recalculateAdditionalInfo,
          customQuantity,
          cb
        )
      }
      {...props}
      presetConfig={presetConfigObject}
      swatchUrl={swatchUrl}
      SKUInventory={SKUInventory}
      comboSkuDetails={comboSkuData}
      priceData={priceData}
      pdpData={authorData}
      isCollapsedPDP={isCollapsedPDP}
      config={config}
      loadShowEvent={loadShowEvent}
      showSaleBadge={showSaleBadge}
      styleOptionsNotPresent={state?.styleOptionsNotPresent}
    />
  ) : (
    <ProgressiveLoader loaderData={{ ...authorData, ...pdpData }} />
  )
}

export default ProductOverview
